module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.10/frontend/_next/static/images/spec-offer-with-label-mobile-dff52960e0520ee46ae896db4eeb7b48.png";